//
// locale_gl.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/gl.json';
import localeData from "react-intl/locale-data/gl.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_gl.js